import { Validator } from '@vista-digital/validator';
import { defaultMemberCardCdnOptions, memberCardCdnOptionsValidator } from './cdn-options';
import { defaultMemberCardConfig, memberCardConfigValidator } from './config';
import { defaultMemberCardDisplayText, memberCardDisplayTextValidator } from './display-text';
export const memberCardPropsValidator = Validator.object({
    config: memberCardConfigValidator,
    displayText: memberCardDisplayTextValidator,
    cdnOptions: memberCardCdnOptionsValidator
});
export const defaultMemberCardProps = {
    config: defaultMemberCardConfig,
    displayText: defaultMemberCardDisplayText,
    cdnOptions: defaultMemberCardCdnOptions
};
